import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface FileUploadResponse {
  status: number;
  issues: boolean;
  message: string;
  result: {
    file_name: string;
    file_url: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class InternshipserviceService {
   private apiUrl = environment.baseUrl + environment.applyIntershipApi;
   private uploadUrl = environment.baseUrl + environment.s3bucket;

  constructor(private http:HttpClient) {}

  submitApplication(data:any): Observable<any>{
    return this.http.post(this.apiUrl,data);
  }

    uploadFile(file: File, name: string): Observable<FileUploadResponse> {

    const formData = new FormData();

    formData.append('name', name);
    formData.append('file', file);

    return this.http.post<FileUploadResponse>(
      `${this.uploadUrl}`,
      formData
    );
  }
}
